import 'css-chunksrc/client/pages/zonePage/projectsPage/toolbar/styles.scss';export default {
  "toolbar": "_toolbar_1uqcc_1",
  "section": "_section_1uqcc_6",
  "title": "_title_1uqcc_12",
  "sort": "_sort_1uqcc_18",
  "filter": "_filter_1uqcc_22"
};